<i18n>
{
  "en": {
    "title": "Company Leadership 2017-2018",
    "description": "Schneider Electric’s leadership team includes its Executive Committee, Board of Directors, and its Advisory Committee. Read about 2017 leadership highlights and learn how the company keeps sustainability at the center of business governance.",
    "companyPerformance": {
      "section": "Company Performance",
      "title": "Company Leadership",
      "leadership": {
        "4col": {
          "txt": {
            "title": "Our Executive Committee",
            "subtitle": "(as of December 30, 2017)"
          },
          "cell1": {
            "name": "Jean-Pascal Tricoire",
            "caption": "Chairman &amp; Chief Executive Officer"
          },
          "cell2": {
            "name": "Emmanuel Babeau",
            "caption": "Deputy Chief Executive Officer in Charge of Finance and Legal Affairs"
          },
          "cell3": {
            "name": "Olivier Blum",
            "caption": "Executive Vice President, Global Human Resources"
          },
          "cell4": {
            "name": "Annette Clayton",
            "caption": "Executive Vice President, Global Supply Chain and North America Operations"
          },
          "cell5": {
            "name": "Hervé Coureil",
            "caption": "Executive Vice President, Information Systems"
          },
          "cell6": {
            "name": "Emmanuel Lagarrigue",
            "caption": "Executive Vice President, Strategy"
          },
          "cell7": {
            "name": "Chris Leong",
            "caption": "Executive Vice President, Global Marketing"
          },
          "cell8": {
            "name": "Christel Heydemann",
            "caption": "Executive Vice President, France Operations"
          }
        },
        "4col2": {
          "cell1": {
            "name": "Leonid Mukhamedov",
            "caption": "Executive Vice President, Europe Operations"
          },
          "cell2": {
            "name": "Luc Rémont",
            "caption": "Executive Vice President, International Operations"
          },
          "cell3": {
            "name": "Yin Zheng",
            "caption": "Executive Vice President, China Operations"
          },
          "cell4": {
            "name": "Frédéric Abbal",
            "caption": "Executive Vice President, Medium Voltage"
          }
        },
        "4col3": {
          "cell1": {
            "name": "Philippe Delorme",
            "caption": "Executive Vice President, Low Voltage – Secure Power"
          },
          "cell2": {
            "name": "Peter Herweck",
            "caption": "Executive Vice President, Industrial Automation"
          }
        },
        "boardTxt": {
          "title": "Board of Directors",
          "p1": "The Board of Directors determines the strategic orientation of our business and oversees its implementation. They also examine all matters related to the efficient operation of our business and make decisions about various issues concerning the company.",
          "p2": "As of April 25, 2017, at the end of the Annual Shareholders’ Meeting, the Board of Directors had 12 members and 1 non-voting member:",
          "li1": "Jean-Pascal Tricoire",
          "li2": "Léo Apotheker",
          "li3": "Betsy Atkins",
          "li4": "Cécile Cabanis",
          "li5": "Xavier Fontanet",
          "li6": "Antoine Gosset-Grainville",
          "li7": "Fred Kindle",
          "li8": "Willy Kissling",
          "li9": "Linda Knoll",
          "li10": "Cathy Kopp",
          "li11": "Xiaoyun Ma",
          "li12": "Gregory Spierkel",
          "li13": "Henri Lachmann (non-voting member)"
        },
        "vid1": {
          "title": "Sustainability in Governance",
          "desc": "Delphine Gieux, Secretary of the Board, Schneider Electric"
        },
        "quote1": {
          "title": "Board of Directors,",
          "company": "Schneider Electric",
          "p1": "As the digital and energy networks converge rapidly, exciting opportunities open up for Schneider Electric to provide new and value-adding services to empower people all over the world to optimize their energy utilization while fighting climate change."
        },
        "snapshot1": {
          "title": "2017 Board of Directors overview",
          "cell1": {
            "title": "Board of Directors",
            "li1": "8 meetings",
            "li2": "90% attendance"
          },
          "cell2": {
            "title": "Audit and Risk",
            "li1": "5 meetings",
            "li2": "100% attendance"
          },
          "cell3": {
            "title": "Human Resources and Corporate Social Responsibility",
            "li1": "3 meetings",
            "li2": "93% attendance"
          },
          "cell4": {
            "title": "Governance and Remuneration",
            "li1": "6 meetings",
            "li2": "96% attendance"
          },
          "cell5": {
            "title": "Strategy",
            "li1": "4 meetings",
            "li2": "85% attendance"
          }
        },
        "quote2": {
          "title": "Board of Directors,",
          "company": "Schneider Electric",
          "p1": "Schneider Electric continues to reach new heights in its sustainability performance. The challenging objectives outlined for the 2018 – 2020 performance period further demonstrate the group-wide commitment to doing our part in making sure the planet has the tools and means to thrive in the new energy future."
        },
        "txtMedia1": {
          "title": "Advisory committee",
          "p1": "Our Advisory Committee is the voice of Schneider Electric’s individual shareholders. The committee consists of up to eight independent volunteers appointed by Schneider Electric and meets three to four times per year to discuss various topics.",
          "p2": "Their main focus is how the company’s strategy affects individual shareholders. The committee works on enhancing communication material and defining dedicated events for shareholders and also plays a role in the Annual Shareholders Meeting, as one of its members opens up the Q&amp;A session with our Chairman and CEO."
        }
      }
    }
  },
  "fr": {
    "title": "Équipe dirigeante 2017-2018",
    "description": "Schneider Electric’s leadership team includes its Executive Committee, Board of Directors, and its Advisory Committee. Read about 2017 leadership highlights and learn how the company keeps sustainability at the center of business governance.",
    "companyPerformance": {
      "section": "Performance de l'Entreprise",
      "title": "L'équipe dirigeante",
      "leadership": {
        "4col": {
          "txt": {
            "title": "Comité Exécutif",
            "subtitle": "(au 14 février 2018)"
          },
          "cell1": {
            "name": "Jean-Pascal Tricoire",
            "caption": "Président Directeur général"
          },
          "cell2": {
            "name": "Emmanuel Babeau",
            "caption": "Directeur général délégué en charge des Finances et des Affaires juridiques"
          },
          "cell3": {
            "name": "Olivier Blum",
            "caption": "Directeur général Ressources humaines globales"
          },
          "cell4": {
            "name": "Annette Clayton",
            "caption": "Directeur général Opérations industrielles et Opérations Amérique du Nord"
          },
          "cell5": {
            "name": "Hervé Coureil",
            "caption": "Directeur général Systèmes d’information"
          },
          "cell6": {
            "name": "Emmanuel Lagarrigue",
            "caption": "Directeur général, Stratégie"
          },
          "cell7": {
            "name": "Chris Leong",
            "caption": "Directeur général, Marketing"
          },
          "cell8": {
            "name": "Christel Heydemann",
            "caption": "Directeur général Opérations France"
          }
        },
        "4col2": {
          "cell1": {
            "name": "Leonid Mukhamedov",
            "caption": "Directeur général Opérations Europe"
          },
          "cell2": {
            "name": "Luc Rémont",
            "caption": "Directeur général Opérations International"
          },
          "cell3": {
            "name": "Yin Zheng",
            "caption": "Directeur général Opérations Chine"
          },
          "cell4": {
            "name": "Frédéric Abbal",
            "caption": "Directeur général Moyenne Tension"
          }
        },
        "4col3": {
          "cell1": {
            "name": "Philippe Delorme",
            "caption": "Directeur général Basse Tension &amp; Energie Sécurisée"
          },
          "cell2": {
            "name": "Peter Herweck",
            "caption": "Directeur général Automatismes Industriels"
          }
        },
        "boardTxt": {
          "title": "Conseil d'administration",
          "p1": "Le Conseil d'administration détermine les orientations stratégiques de notre activité et veille à leur mise en œuvre. Il étudie également toute question interéssant la bonne marche de notre société  et règle par ses délibérations les affaires qui la concernent.",
          "p2": "Le 25 avril 2017, à l'issue de l'Assemblée Générale des actionnaires, le conseil d'administration compte 12 administrateurs et un censeur:",
          "li1": "Jean-Pascal Tricoire",
          "li2": "Léo Apotheker",
          "li3": "Betsy Atkins",
          "li4": "Cécile Cabanis",
          "li5": "Xavier Fontanet",
          "li6": "Antoine Gosset-Grainville",
          "li7": "Fred Kindle",
          "li8": "Willy Kissling",
          "li9": "Linda Knoll",
          "li10": "Cathy Kopp",
          "li11": "Xiaoyun Ma",
          "li12": "Gregory Spierkel",
          "li13": "Henri Lachmann (censeur)"
        },
        "vid1": {
          "title": "Développement Durable et Gouvernance",
          "desc": "Delphine Gieux, Secrétaire du Conseil d’administration, Schneider Electric"
        },
        "quote1": {
          "title": "Conseil d’administration,",
          "company": "Schneider Electric",
          "p1": "Dans un contexte de convergence rapide des réseaux numériques et de l’énergie, Schneider Electric voit émerger de belles opportunités de fournir de nouveaux services à forte valeur ajoutée qui donnent à chacun de nous, dans le monde entier, la possibilité d'optimiser sa consommation d’énergie tout en luttant contre le changement climatique."
        },
        "snapshot1": {
          "title": "Activités du conseil d'administration en 2017",
          "cell1": {
            "title": "Conseil d'administration",
            "li1": "8 réunions",
            "li2": "90 % de taux de participation"
          },
          "cell2": {
            "title": "Comité d’audit et des risques",
            "li1": "5 réunions",
            "li2": "100 % de taux de participation"
          },
          "cell3": {
            "title": "Comité des ressources humaines et RSE",
            "li1": "3 réunions",
            "li2": "93 % de taux de participation"
          },
          "cell4": {
            "title": "Comité de gouvernance et des rémunérations",
            "li1": "6 réunions",
            "li2": "96 % de taux de participation"
          },
          "cell5": {
            "title": "Comité stratégie",
            "li1": "4 réunions",
            "li2": "85 % de taux de participation"
          }
        },
        "quote2": {
          "title": "Conseil d'administration,",
          "company": "Schneider Electric",
          "p1": "Schneider Electric continue d’atteindre de nouveaux sommets de performance en matière de Développement Durable. Les objectifs ambitieux fixés pour la période 2018-2020 illustrent bien l’engagement du Groupe à faire sa part pour s'assurer que la planète ait les moyens de prospérer malgré le changement de paradigme énergétique."
        },
        "txtMedia1": {
          "title": "Comité consultatif",
          "p1": "Le Comité consultatif des actionnaires est la voix des actionnaires individuels de Schneider Electric. Le Groupe désigne jusqu’à huit membres volontaires indépendants, qui se réunissent trois à quatre fois par an pour débattre de divers sujets, en accordant une attention toute particulière à la manière dont la stratégie de l’entreprise affecte les actionnaires individuels. Le Comité œuvre à l’amélioration des supports de communication et à l’organisation d'événements dédiés pour les actionnaires. Il joue également un rôle actif lors de l’assemblée générale, puisque l’un de ses membres ouvre la séance de questions-réponses avec notre Président Directeur général.",
          "p2": "&nbsp;"
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('@/assets/img/company-performance/company-leadership-hero-lores.jpg')" :hiResSrc="require('@/assets/img/company-performance/company-leadership-hero.jpg')" chapter="06" :section="$t('companyPerformance.section')" :title="$t('companyPerformance.title')"/>

    <section class="m-b-120 m-t-120">
      <FourCols>
        <div slot="above">
          <h2 v-html="$t('companyPerformance.leadership.4col.txt.title')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col.txt.subtitle')"/>
        </div>
        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Jean-Pascal_Tricoire_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col.cell1.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col.cell1.caption')"/>
        </FourColsItem>

        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Emmanuel-Babeau_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col.cell2.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col.cell2.caption')"/>
        </FourColsItem>

        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Olivier-Blum_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col.cell3.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col.cell3.caption')"/>
        </FourColsItem>

        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Annette-Clayton_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col.cell4.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col.cell4.caption')"/>
        </FourColsItem>
      </FourCols>
      <FourCols :above="false">
        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Herve-Coureil_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col.cell5.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col.cell5.caption')"/>
        </FourColsItem>

        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Emmanuel-Lagarrigue_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col.cell6.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col.cell6.caption')"/>
        </FourColsItem>

        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Chris-Leong_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col.cell7.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col.cell7.caption')"/>
        </FourColsItem>
        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Christel Heydemann_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col.cell8.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col.cell8.caption')"/>
        </FourColsItem>
      </FourCols>

      <FourCols>
        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Leonid-Mukhamedov2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col2.cell1.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col2.cell1.caption')"/>
        </FourColsItem>

        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Luc-Rémont_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col2.cell2.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col2.cell2.caption')"/>
        </FourColsItem>

        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Zheng-Yin_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col2.cell3.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col2.cell3.caption')"/>
        </FourColsItem>
        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Frederic-Abbal_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col2.cell4.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col2.cell4.caption')"/>
        </FourColsItem>
      </FourCols>

      <FourCols>
        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Philippe-Delorme_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col3.cell1.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col3.cell1.caption')"/>
        </FourColsItem>

        <FourColsItem>
          <img src="@/assets/img/company-performance/leadership/Peter-Herweck_2017-18.jpg" alt="">
          <p class="t-chartbody t-darker-grey" v-html="$t('companyPerformance.leadership.4col3.cell2.name')"/>
          <p class="t-caption" v-html="$t('companyPerformance.leadership.4col3.cell2.caption')"/>
        </FourColsItem>
      </FourCols>
    </section>

    <hr>

    <section class="m-t-120 m-b-120">
      <Txt>
        <h2 id="boardofdirectors" v-html="$t('companyPerformance.leadership.boardTxt.title')"></h2>
        <p v-html="$t('companyPerformance.leadership.boardTxt.p1')"></p>
        <p v-html="$t('companyPerformance.leadership.boardTxt.p2')"></p>
        <ul>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li1')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li2')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li3')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li4')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li5')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li6')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li7')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li8')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li9')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li10')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li11')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li12')"></li>
          <li v-html="$t('companyPerformance.leadership.boardTxt.li13')"></li>
        </ul>
      </Txt>
    </section>

    <hr>

    <section class="m-b-120 m-t-120">
      <YouTubeVideo videoId="L3ZlXtD4-_w" :title="$t('companyPerformance.leadership.vid1.title')" :description="$t('companyPerformance.leadership.vid1.desc')" :preview="require('@/assets/img/thumbnails/SSDHighlightVideo_DelphineGieux_Still.jpg')" />
    </section>

    <section class="m-b-120">
      <Quote :photo="require('@/assets/img/company-performance/leadership/quote1.jpg')" name="Léo Apotheker" :title="$t('companyPerformance.leadership.quote1.title')" :company="$t('companyPerformance.leadership.quote1.company')">
        <div v-html="$t('companyPerformance.leadership.quote1.p1')"></div>
      </Quote>
    </section>

    <section class="m-b-120 m-t-120">
      <Snapshot>
        <div slot="above">
          <h2 id="boardoverview" v-html="$t('companyPerformance.leadership.snapshot1.title')" />
        </div>
        <SnapshotCard class="t-white" :double="true" :bgimg="require('@/assets/img/company-performance/GettyImages-575131345.jpg')">
          <h3 class="" v-html="$t('companyPerformance.leadership.snapshot1.cell1.title')"></h3>
          <div class="t-hr"></div>
          <p class="t-chartbody t-white" v-html="$t('companyPerformance.leadership.snapshot1.cell1.li1')"></p>
          <p class="t-chartbody t-white" v-html="$t('companyPerformance.leadership.snapshot1.cell1.li2')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#626469">
          <h3 class="" v-html="$t('companyPerformance.leadership.snapshot1.cell2.title')"></h3>
          <div class="t-hr"></div>
          <p class="t-chartbody t-white" v-html="$t('companyPerformance.leadership.snapshot1.cell2.li1')"></p>
          <p class="t-chartbody t-white" v-html="$t('companyPerformance.leadership.snapshot1.cell2.li2')"></p>
        </SnapshotCard>

        <SnapshotCard :double="false">
          <h3 class="t-green-light" v-html="$t('companyPerformance.leadership.snapshot1.cell5.title')"></h3>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.leadership.snapshot1.cell5.li1')"></p>
          <p class="t-chartbody" v-html="$t('companyPerformance.leadership.snapshot1.cell5.li2')"></p>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <h3 class="t-green-light" v-html="$t('companyPerformance.leadership.snapshot1.cell4.title')"></h3>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.leadership.snapshot1.cell4.li1')"></p>
          <p class="t-chartbody" v-html="$t('companyPerformance.leadership.snapshot1.cell4.li2')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" :double="true" bgc="#3dcd58">
          <h3 class="" v-html="$t('companyPerformance.leadership.snapshot1.cell3.title')"></h3>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.leadership.snapshot1.cell3.li1')"></p>
          <p class="t-chartbody" v-html="$t('companyPerformance.leadership.snapshot1.cell3.li2')"></p>
        </SnapshotCard>
      </Snapshot>
    </section>

    <section class="m-b-120">
      <Quote :photo="require('@/assets/img/company-performance/leadership/quote2.jpg')" name="Linda Knoll" :title="$t('companyPerformance.leadership.quote2.title')" :company="$t('companyPerformance.leadership.quote2.company')">
        <div v-html="$t('companyPerformance.leadership.quote2.p1')"></div>
      </Quote>
    </section>

    <section class="m-b-120">
      <TxtMedia>
        <h2 slot="main-content" v-html="$t('companyPerformance.leadership.txtMedia1.title')" />
        <p slot="main-content" v-html="$t('companyPerformance.leadership.txtMedia1.p1')" />
        <p slot="main-content" v-html="$t('companyPerformance.leadership.txtMedia1.p2')" />
        <img slot="sidebar" src="@/assets/img/company-performance/leadership/SE-Shareholders_SSD2017.jpg" alt="">
      </TxtMedia>
    </section>

   <div class="l-content">
      <FooterNav
        nextRoute="CompanyPerformance_Ethics"
        prevRoute="CompanyPerformance_20152017PlanetSocietyBarometer" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import References from '@/components/References'
import Reference from '@/components/Reference'
import YouTubeVideo from '@/components/YouTubeVideo'
import TxtMedia from '@/components/TxtMedia'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'

export default {
  name: 'CompanyPerformance_CompanyLeadership',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    References,
    Reference,
    YouTubeVideo,
    TxtMedia,
    Snapshot,
    SnapshotCard
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company-performance/company-leadership.vue